import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BASE_CLIENT, BaseClient} from "../../client/base.client";

@Component({
  selector: 'yz-file-show',
  templateUrl: './yz-file-show.component.html',
  styleUrls: ['./yz-file-show.component.less']
})
export class YzFileShowComponent implements OnInit, AfterViewInit {

  fileId: string = null;
  iframeSrc: SafeResourceUrl;
  loading: boolean = false;

  constructor(private sanitizer: DomSanitizer,
              public dialogRef: MatDialogRef<YzFileShowComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              @Inject(BASE_CLIENT) private client: BaseClient) {
  }

  ngOnInit() {
    this.fileId = this.data.id;
    this.loading = true;
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.client.gateway + '/filecenter/preview/' + this.fileId);
  }

  closeIframe() {
    this.dialogRef.close();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const _iframe = <HTMLIFrameElement>document.getElementById('yz-file-show-iframe');
      const _iframeHeader = _iframe.contentWindow.document.getElementsByTagName('header')[0] as HTMLElement;
      const _iframeContent = _iframe.contentWindow.document.getElementsByClassName('content')[0] as HTMLElement;
      _iframeHeader.style.display = 'none';
      _iframeContent.style.paddingTop = '0';
      this.loading = false;
    }, 1000);
  }
}
